import { FC } from 'react'
import { Icon, IconButton } from '@branch-messenger/willow-ui'
import { X } from '@branch-messenger/willow-ui/icons'
import { fireMixpanelEvent } from '@lib/analytics'
import { fireOnboardingComplete } from '@lib/parentMessageEvents'
import { useAppNavigate } from '@src/routes/-utils/useAppNavigate'

import { useStoreState } from '../../store'

export const FlowCardExit: FC = () => {
  const navigate = useAppNavigate()
  const instanceId = useStoreState(state => state.onboarding.instanceId)
  const callbackUrl = useStoreState(state => state.onboarding.callbackUrl)
  const userId = useStoreState(state => state.onboarding.userId)

  const onExit = () => {
    if (!userId) {
      navigate({ to: '/confirmExit' })
    } else {
      fireMixpanelEvent('confirmExit:exit.tap')
      fireOnboardingComplete(callbackUrl, instanceId)
    }
  }

  return (
    <IconButton onClick={onExit} size="sm">
      <Icon Icon={X} size={6} />
    </IconButton>
  )
}
